export enum UserRoles {
  superAdmin = 'SUPER_ADMIN',
  admin = 'ADMIN',
  restaurantAdmin = 'RESTAURANT_ADMIN',
  waiter = 'WAITER',
  viewer = 'VIEWER'
}
